@file:kotlin.js.JsExport
package com.narbase.letsgo.web.routing.domain.admin.rides
import com.narbase.letsgo.dto.core.KmmLong

import com.narbase.letsgo.router.EndPoint

object CompleteRideAdminEndpoint
    : EndPoint<CompleteRideAdminEndpoint.Request, CompleteRideAdminEndpoint.Response>() {
    class Request(
        val rideId: KmmLong,
    )

    class Response()
}